import { EnvironmentProviders, inject, provideEnvironmentInitializer } from '@angular/core';
import { CoreStore } from './core.store';

export function provideCoreInit(): EnvironmentProviders {
	return provideEnvironmentInitializer(() => {
		inject(CoreStore).init();
	});
}
